import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

const GOIFieldString = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const { placeholder } = inputData.options;

  const handleValueChange = (e) => {
    let inputValue = e.target.value;
    onInputValueChange(inputData.id, inputValue);
  };

  return (
    <input
      type="string"
      defaultValue={value}
      placeholder={placeholder}
      onChange={handleValueChange}
      disabled={disabled}
    />
  );
};

export default GOIFieldString;
